import { render, staticRenderFns } from "./HeaderBoard.vue?vue&type=template&id=9af4fa2e"
import script from "./HeaderBoard.vue?vue&type=script&lang=js"
export * from "./HeaderBoard.vue?vue&type=script&lang=js"
import style0 from "./HeaderBoard.vue?vue&type=style&index=0&id=9af4fa2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports